<template>
  <el-input :value="value" type="textarea" :placeholder="placeholder" :size="size" @input="change($event)" />
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'placeholder', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TextArea.vue